import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { SesionUsuario } from '../interfaces/SesionUsuario.interface';
import { Store } from '@ngrx/store';
import { MicrosoftAuthService } from '../services/microsoft-auth.service';
import { MsalService } from '@azure/msal-angular';
import { selectorSesionUsuario } from '../state/selectors/login.selector';
import { AppState } from '../state/app.state';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftRolesGuard  {
  sesion$: Observable<SesionUsuario> | undefined;
  loading: Observable<boolean> = new Observable();

  constructor(
    private _router: Router,
    private store: Store<AppState>,
    private _auth: MicrosoftAuthService,
    private msalAuthService: MsalService
  ) {
    this.store.select(selectorSesionUsuario).subscribe((data) => {
      if (!data?.roles) {
        this._auth.login();

        setTimeout(() => {
          this.sesion$ = this.store.select(selectorSesionUsuario);
        }, 1000);
      }
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable((observer) => {
      setTimeout(() => {
        let test = this.store.select(selectorSesionUsuario).pipe(
          map((sesion: SesionUsuario) => {
            if (sesion.roles) {
              const rolesUsuario = JSON.parse(sesion.roles);
              const rolesRuta: [] = next.data['rolUsuario'];

              let allow: boolean = false;

              if (rolesRuta.some((e) => rolesUsuario.includes(e))) {
                allow = true;
                observer.next(allow);
                return allow;
              } else {
                if (sesion.isLoggedIn === true) {
                  localStorage.clear();
                  this._router.navigate(['admin/registros']);
                } else {
                  this._router.navigate(['admin/login']);
                }

                return allow;
              }
            } else {
              return false;
            }
          })
        );

        test.subscribe((data) => {});
      }, 1000);
    });
  }
}
